<!--  -->
<template>
  <div class="relief-nav-bar" :style="[style_bgc, style_bg, style_fixed,style_height]">
    <div class="left" :style="{ color: fontColor }" @click="leftBack">
      <!-- <van-icon name="arrow-left" :style="{ color: fontColor }" /> -->
      <img
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAkBAMAAAAaxSXRAAAAFVBMVEUAAAATFRUTFRUSFBQSFRUTExYTFBVuIh2DAAAABnRSTlMArohxY1IX2rJpAAAAM0lEQVQoz2PACZgN0ATEUlD5jGmpaArSFNAUJA0DBcwIBQgB/FoYGIehklS8yQGRYDABABbZFn1qi6llAAAAAElFTkSuQmCC"
        :style="{ color: fontColor }"
      />
    </div>
    <div
      class="title"
      :style="{ color: fontColor,fontWeight:titleWeight }"
      v-if="titleText"
    >{{ titleText }}</div>
    <div
      class="right"
      :style="{ color: rigthFontColor,fontWeight:rightWeight,fontSize:rightSize }"
      v-if="rightText"
      @click="rightTextEvent"
    >{{ rightText }}</div>
  </div>
</template>



<script>
export default {
  name: "navBar",
  data() {
    return {};
  },
  props: {
    titleText: {
      type: String,
    },
    rightText: {
      type: String,
    },
    fontColor: {
      type: String,
      defult: "#ffffff",
    },
    rigthFontColor: {
      type: String,
      defult: "#ffffff",
    },
    titleWeight: {
      type: String,
      defult: "none",
    },
    rightWeight: {
      type: String,
      defult: "none",
    },
    rightSize: {
      type: String,
      defult: "14px",
    },
    bgc: {
      type: String,
    },
    bg: {
      type: String,
    },
    isFixed: {
      type: Boolean,
      default: true,
    },
    height: {
      type: String,
    },
  },
  computed: {
    style_bgc: function () {
      return {
        "background-color": this.bgc,
      };
    },
    style_bg: function () {
      return {
        background: this.bg,
      };
    },
    style_fixed: function () {
      return this.isFixed
        ? {
            position: "fixed",
            top: 0,
            "z-index": 100,
            padding: "44px 0 0",
          }
        : {};
    },
    style_height: function () {
      return {
        height: this.height,
      };
    },
  },
  methods: {
    leftBack() {
      this.$emit("goBack");
    },
    rightTextEvent() {
      this.$emit("rightTextEvent");
    },
  },
};
</script>

<style scoped lang='less'>
.relief-nav-bar {
  width: 100%;
  background: #fff;
  height: 44px;
  padding: 44px 0 0px;
  line-height: 44px;
  position: relative;
  .left {
    width: 17px;
    height: 17px;
    line-height: 17px;
    display: inline-block;
    position: absolute;
    top: 61px;
    margin: 0 21px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .title {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
  }
  .right {
    position: absolute;
    right: 0;
    margin: 0 16px;
    top: 52px;
    height: 29px;
    line-height: 29px;
  }
}
</style>
